import { SubRoute } from './types';

export type ModuleRoutes = { root: SubRoute } & Record<string, SubRoute>;

export const createModuleRoutes = <T extends ModuleRoutes>(routes: T) => routes;
